import React, { useEffect, useState } from "react";
import api from "../../lib/api";
import { Button } from "../../components/ui/button";
import { toast } from "sonner";
import { Sparkles } from "lucide-react";

const STAGES = ["lead", "contacted", "quoted", "negotiation", "confirmed", "recurring"];
const STAGE_COLORS = {
  lead: "bg-muted",
  contacted: "bg-blue-100 text-blue-900",
  quoted: "bg-amber-100 text-amber-900",
  negotiation: "bg-orange-100 text-orange-900",
  confirmed: "bg-green-100 text-green-900",
  recurring: "bg-[hsl(var(--primary))] text-white",
};

export default function AdminCRM() {
  const [leads, setLeads] = useState([]);
  const [scoring, setScoring] = useState(null);
  useEffect(() => { api.get("/admin/leads").then(r => setLeads(r.data)); }, []);

  const score = async (id) => {
    setScoring(id);
    try {
      const r = await api.post(`/admin/leads/${id}/score`);
      setLeads(prev => prev.map(l => l.id === id ? { ...l, score: r.data.score, ai_insights: r.data } : l));
      toast.success(`Score AI: ${r.data.score}`);
    } catch { toast.error("AI error"); } finally { setScoring(null); }
  };

  const byStage = STAGES.map(s => ({ stage: s, items: leads.filter(l => l.stage === s) }));

  return (
    <div data-testid="admin-crm-page">
      <div className="flex items-center justify-between">
        <h1 className="editorial-heading text-4xl">CRM · Pipeline Leads</h1>
      </div>
      <div className="mt-6 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3">
        {byStage.map(col => (
          <div key={col.stage} data-testid={`crm-col-${col.stage}`} className="bg-card border border-border rounded-sm p-3 min-h-[300px]">
            <div className={`text-[10px] uppercase tracking-[0.2em] font-bold px-2 py-1 rounded-sm ${STAGE_COLORS[col.stage]}`}>{col.stage} · {col.items.length}</div>
            <div className="mt-3 space-y-2">
              {col.items.map(l => (
                <div key={l.id} data-testid={`crm-lead-${l.id}`} className="bg-[hsl(var(--muted))] rounded-sm p-2.5">
                  <div className="font-semibold text-sm">{l.name}</div>
                  <div className="text-[11px] text-muted-foreground truncate">{l.company}</div>
                  <div className="flex items-center justify-between mt-2">
                    <div className="text-xs font-bold text-[hsl(var(--primary))]">Score {l.score}</div>
                    <div className="text-xs text-muted-foreground">€{(l.value_potential/1000).toFixed(0)}k</div>
                  </div>
                  <Button data-testid={`crm-score-${l.id}`} onClick={() => score(l.id)} disabled={scoring === l.id} size="sm" variant="ghost" className="w-full mt-2 text-[10px] h-7 gap-1 text-[hsl(var(--primary))]">
                    <Sparkles className="h-3 w-3"/>{scoring === l.id ? "AI…" : "AI Score"}
                  </Button>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
